import { Injectable } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";

@Injectable({
    providedIn: 'root'
})
export class FrequencyService {

    constructor(        
        private translate: TranslateService,
    ) {}

    daysOfWeek = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];

    getMonthDays(){
        const daysOfMonth = [];
        for (let i = 1; i <= 31; i++) {
            daysOfMonth.push(i);
        }
        return daysOfMonth;
    }

    getWeekDays(){        
        return this.daysOfWeek.map((day, index) => {
            return {
                value: index + 1,
                label: this.translate.instant(day)
            }
        });
    }

    getFrequency(){
        return [{
            value: 'weekly',
            label: this.translate.instant('digests_setting.frequency.weekly')
        },
        {
            value: 'monthly',
            label: this.translate.instant('digests_setting.frequency.monthly')
        }];
    }
}